<template functional>
  <section class="about-us-investors mb9">
    <div class="page-container">
      <div class="about-us-investors__wrapper text-left relative" data-aos="fade-up">
        <h2 class="about-us-investors__title mb5">
          We&nbsp;believe sales is&nbsp;
          <em>the future.</em>
          Our investors agree.
        </h2>

        <p class="about-us-investors__subtitle pr3">
          Hiring great salespeople is&nbsp;the #1 challenge at&nbsp;every growing company. That&rsquo;s why our
          investors are so&nbsp;passionate about backing Bravado: the only global job pairing platform for salespeople.
        </p>

        <div class="about-us-investors__logos flex flex-column pt4">
          <div class="about-us-investors__logos-row">
            <img
              src="../images/logos/tiger-global-logo.svg"
              class="about-us-investors__logo--tiger-global"
              width="164"
              height="16"
              alt="Tiger Global"
              loading="lazy"
              decoding="async"
            />
            <img
              src="../images/logos/redpoint-logo.svg"
              class="about-us-investors__logo--redpoint"
              width="110"
              height="22"
              alt="Redpoint"
              loading="lazy"
              decoding="async"
            />
            <img
              src="../images/logos/socialcapital-logo.svg"
              class="about-us-investors__logo--social-capital"
              width="180"
              height="16"
              alt="Social Capital"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="about-us-investors__logos-row">
            <img
              src="../images/logos/kindred-ventures-logo.svg"
              class="about-us-investors__logo--kindred-ventures"
              width="62"
              height="22"
              alt="Kindred Ventures"
              loading="lazy"
              decoding="async"
            />
            <img
              src="../images/logos/freestyle-logo.svg"
              class="about-us-investors__logo--freestyle"
              width="98"
              height="28"
              alt="Freestyle"
              loading="lazy"
              decoding="async"
            />
            <img
              src="../images/logos/precursor-ventures-logo.svg"
              class="about-us-investors__logo--precursor-ventures"
              width="83"
              height="21"
              alt="Precursor Ventures"
              loading="lazy"
              decoding="async"
            />
            <img
              src="../images/logos/xyz-logo.svg"
              class="about-us-investors__logo--xyz"
              width="52"
              height="18"
              alt="XYZ"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUsInvestors',
  functional: true,
};
</script>

<style lang="scss" scoped>
.about-us-investors {
  @include mq('md') {
    margin-bottom: 115px;
  }

  &__wrapper {
    background: url('~@/components/partials/landings/about-us/images/bg/investors-bg.svg') no-repeat center top
      var(--white);
    background-size: cover;
    border-radius: 16px;
    z-index: 1;
    padding: 35px 15px 24px 20px;

    @include mq('md') {
      border-radius: 32px;
      text-align: center;
      padding: 70px 24px 30px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    color: var(--color-text);

    @include mq('md') {
      font-size: 33px;
      line-height: 40px;
      letter-spacing: -1px;
      margin-bottom: 24px;
    }

    em {
      font-style: normal;
      color: var(--gold-40);
      position: relative;
      white-space: nowrap;

      @include mq('md') {
        font-style: italic;
        margin-right: 2px;
      }

      &::after {
        content: '';
        height: 8px;
        width: 125px;
        background: url('~@/components/partials/landings/about-us/images/bg/investors-underline.svg') no-repeat left top;
        background-size: 115px 8px;
        position: absolute;
        bottom: -6px;
        left: -8px;

        @include mq('md') {
          width: 165px;
          background-size: auto;
          bottom: -6px;
          left: -8px;
        }
      }
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--color-text);
    max-width: 660px;

    @include mq('md') {
      font-size: 17px;
      margin: 0 auto 10px;
      padding: 0;
    }
  }

  &__logos {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;

    &-row {
      display: flex;
      gap: 24px;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 8px 0;

      @include mq('md') {
        padding: 16px 0;
        gap: 40px;
      }

      img {
        width: 30%;

        @include mq('md') {
          gap: 40px;
        }
      }
    }
  }

  &__logo {
    &--kindred-ventures {
      max-width: 40px;
      margin-left: 7%;
    }

    &--xyz {
      max-width: 30px;
      margin-right: 7%;
    }

    @include mq('md') {
      &--redpoint {
        max-width: 110px;
        margin: 0 20px;
      }

      &--tiger-global {
        max-width: 164px;
      }

      &--social-capital {
        max-width: 197px;
      }

      &--kindred-ventures {
        max-width: 62px;
      }

      &--freestyle {
        max-width: 98px;
      }

      &--precursor-ventures {
        max-width: 83px;
      }

      &--xyz {
        max-width: 52px;
      }
    }
  }
}
</style>
